<template>
    <div :class="{ web: isPc, mobile: !isPc }">
        <section class="footer-banner">
            <router-link class="footer-router" to="/">
                <img src="../images/logo-viemao-title.webp" alt="viemaoLogo" />
            </router-link>
            <div class="footer-guide">
                <router-link class="guide-item" to="/terms-of-service">{{
                    t("viemao_downloader_footer_para1")
                }}</router-link>
                <router-link class="guide-item" to="/privacy-policy">{{
                    t("viemao_downloader_footer_para3")
                }}</router-link>
                <router-link class="guide-item" to="/cookies-policy">{{
                    t("viemao_downloader_footer_para4")
                }}</router-link>
                <router-link class="guide-item" to="/usage-guidelines">{{
                    t("viemao_downloader_footer_para5")
                }}</router-link>
            </div>
        </section>
    </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();

defineProps({
    isPc: {
        type: Boolean,
        required: true,
        default: false,
    },
});
</script>

<style lang="scss" scoped>
.web {
    .footer-banner {
        display: flex;
        padding: 48px 80px;
        background: #f9fafb;
        align-items: center;
        justify-content: space-between;
        img {
            width: 150px;
        }
        .footer-guide {
            display: flex;
            gap: 16px;
            color: #667085;

            .guide-item {
                font-family: Inter-Regular;
                font-size: 16px;
                line-height: 24px;
                text-decoration: none;
                color: #667085;
                cursor: pointer;
            }
        }
    }
}

.mobile {
    .footer-banner {
        display: flex;
        flex-direction: column;
        padding: 0.48rem 0.16rem;
        gap: 0.32rem;
        background: #f9fafb;
        justify-content: space-between;
        .footer-router {
            display: flex;
        }
        img {
            width: 1.5rem;
        }
        .footer-guide {
            display: flex;
            flex-direction: column;
            gap: 0.12rem;
            color: #667085;

            .guide-item {
                font-family: Inter-Regular;
                font-size: 0.16rem;
                line-height: 0.24rem;
                text-decoration: none;
                color: #667085;
                cursor: pointer;
            }
        }
    }
}
</style>
